(function (Translator) {
    // sq
    Translator.add("administration.user_search_button", "K\u00ebrko", "EvpAdministrationBundle", "sq");
    Translator.add("administration.user_search_label", "ID e p\u00ebrdoruesit", "EvpAdministrationBundle", "sq");
    Translator.add("forbidden", "Nuk lejohet", "EvpAdministrationBundle", "sq");
    Translator.add("internal_server_error", "Gabim n\u00eb server", "EvpAdministrationBundle", "sq");
    Translator.add("invalid_code", "Kod i pavlefsh\u00ebm", "EvpAdministrationBundle", "sq");
    Translator.add("invalid_grant", "Akses i refuzuar", "EvpAdministrationBundle", "sq");
    Translator.add("invalid_parameters", "Parametra t\u00eb pavlefsh\u00ebm", "EvpAdministrationBundle", "sq");
    Translator.add("invalid_request", "K\u00ebrkes\u00eb jo e sakt\u00eb", "EvpAdministrationBundle", "sq");
    Translator.add("invalid_state", "Status i pavlefsh\u00ebm", "EvpAdministrationBundle", "sq");
    Translator.add("limits_exceeded", "Limit i arritur", "EvpAdministrationBundle", "sq");
    Translator.add("logout", "Dilni", "EvpAdministrationBundle", "sq");
    Translator.add("not_acceptable", "Nuk pranohet", "EvpAdministrationBundle", "sq");
    Translator.add("not_found", "Nuk u gjet", "EvpAdministrationBundle", "sq");
    Translator.add("pagination.first", "E para", "EvpAdministrationBundle", "sq");
    Translator.add("pagination.last", "E fundit", "EvpAdministrationBundle", "sq");
    Translator.add("pagination.next", "Tjetra", "EvpAdministrationBundle", "sq");
    Translator.add("pagination.page_out_of", "forma", "EvpAdministrationBundle", "sq");
    Translator.add("pagination.previous", "Prapa", "EvpAdministrationBundle", "sq");
    Translator.add("rate_limit_exceeded", "Limit i arritur", "EvpAdministrationBundle", "sq");
    Translator.add("unauthorized", "Akses i refuzuar", "EvpAdministrationBundle", "sq");
})(Translator);
